import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Script from "next/script";
import { useConfigContext } from "../../app/runtime-config/ConfigContext.js";
export function SmartFormIntegration() {
    const { smartformClientId } = useConfigContext();
    if (!smartformClientId) {
        return null;
    }
    //TODO: hard binding to the specific fields in the form, should be made more generic in the future:
    return (_jsxs(_Fragment, { children: [_jsx(Script, { src: "https://client.smartform.cz/v2/smartform.js" }), _jsx(Script, { id: "smart-form-init", children: `
                    var smartform = window.smartform || {};
                    smartform.beforeInit = function () {
                        smartform.setClientId("${smartformClientId}");
                    };

                    function addressValidationCallback(validationResult) {
                        if (validationResult.result.type !== smartform.AddressValidationResultType.HIT) {
                            return;
                        }
                        const zipField = document.querySelector(".smartform-address-zip");
                        if (!zipField) {
                            return;
                        }
                        zipField.focus();
                    }

                    smartform.afterRebind = function () {
                        const addressInstance = smartform.getInstance('smartform-instance-address');
                        if (!addressInstance) {
                            return;
                        }
                        addressInstance.addressControl.addValidationCallback(addressValidationCallback);
                        addressInstance.addressControl.setFocusNextFieldEnabled(false);
                    };
                ` })] }));
}
